export const ACTION_ITEM_IDS = {
  USER_ACCOUNT: 'userAccount',
  WISHLIST: 'wishlist',
  CART: 'cart',
} as const;

export type ActionItemId = (typeof ACTION_ITEM_IDS)[keyof typeof ACTION_ITEM_IDS];
